module.exports = __webpack_public_path__ + "b5360d1958a1af2158fbf990b82b051a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Balzano.woff?v=1.00
// module id = 936
// module chunks = 24